<template>
    <div> <h1> Cloud Dashboard Sayfası {{getEnvironmetMessage()}} </h1> </div>
</template>
<script>

import { AppConfiguration } from "read-appsettings-json";
export default {
   
  
 
    methods: 
    {
        getEnvironmetMessage: function()
        {

           
return  AppConfiguration.Setting().environmentMessage;
        }
    }
}
</script>
